var render, staticRenderFns
import script from "./flexbox.vue?vue&type=script&lang=js&"
export * from "./flexbox.vue?vue&type=script&lang=js&"
import style0 from "./flexbox.vue?vue&type=style&index=0&id=874de5c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874de5c6",
  null
  
)

export default component.exports